import { render } from "./chart.vue?vue&type=template&id=59e878cc"
import script from "./chart.vue?vue&type=script&lang=ts"
export * from "./chart.vue?vue&type=script&lang=ts"
script.render = render

export default script